// extracted by mini-css-extract-plugin
export default {"back-button-container":"BackButton_back-button-container__K-Rov","back-button-span":"BackButton_back-button-span__P3EY2","back-button-icon":"BackButton_back-button-icon__uDlC6"};